import { usePostHttp } from "../../http.hook";
import type { IOtp } from "../../../../types/models/otp.models.types";

interface IBody {
  identifierType: string;
  identifier: string;
}

interface IOtpResponse extends IOtp {}

export function useEphemeralSendOtpCommonHttp() {
  return usePostHttp<IBody, IOtpResponse>({
    path: "/common/users/authentication/send-otp",
  });
}
